import { render, staticRenderFns } from "./PositionListAdmin.vue?vue&type=template&id=291a6ba2"
import script from "./PositionListAdmin.vue?vue&type=script&lang=js"
export * from "./PositionListAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports